import script from "./CreateButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateButton.vue?vue&type=script&lang=ts&setup=true"

import "./CreateButton.vue?vue&type=style&index=0&id=624c439e&lang=css&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624c439e"]])

export default __exports__